export default __webpack_public_path__ + "static/column-trainer-3-301726bd9baf914832b70b7128c100b5.jpg";